export interface SocialNet {
  id: number;
  type: SocialNetType;
  url: string;
}

export enum SocialNetType {
  VK = 'VK',
  VK_VIDEO = 'VK_VIDEO',
  TELEGRAM = 'TELEGRAM',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  TOURNAMENT_SITE = 'TOURNAMENT_SITE',
}
